import services from "@src/Services";

import { getCustomExtraPathDashboard } from "../helper";

export const InitialState = {
  closed: undefined,
  last_updated: undefined,
  open: undefined,
};

export const getCheckSummaryData = async (customFilter: FilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathDashboard({
      ...customFilter,
    });

    const customPath = `${advancedFilterExtraPath}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/checks-summary${customPath}`);

    if (!res?.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
